import React from 'react'
import { Box, Grid, InfoOutlineIcon } from 'src/ui'
import { transformGroupNameToTitleCase } from 'src/utils/tenant-configuration'
import { FormControl, FormLabel } from 'src/ui/form-controls'
import ConfigurationPanelFormField from './ConfigurationPanelFormField'
import { JsonSchemaTooltip } from 'src/components/JsonSchemaTooltip'

interface ConfigurationPanelFieldsProps {
  formFields: { [key: string]: TenantConfiguration[] }
  fieldPathPrefix?: string
}

export default function ConfigurationPanelFields({
  formFields,
  fieldPathPrefix = 'fields',
}: Readonly<ConfigurationPanelFieldsProps>) {
  return (
    <>
      {Object.entries(formFields).map(([groupName, groupConfigs], groupIndex) => {
        return (
          <Box key={groupName} bg={groupIndex % 2 === 1 ? 'gray.50' : undefined} px={6}>
            <Box fontWeight="bold" py={4}>
              {transformGroupNameToTitleCase(groupName)}
            </Box>
            <Grid templateColumns="repeat(auto-fit, minmax(300px, 1fr))" columnGap={4}>
              {groupConfigs.map((form, index) => (
                <Box
                  key={form.key}
                  display="flex"
                  alignItems="flex-start"
                  flex="1"
                  minWidth="0"
                  py="2"
                >
                  <Box w="full">
                    <FormControl height="unset" minH="72px" mb={null}>
                      <FormLabel
                        htmlFor={`${fieldPathPrefix}.${form.group}.${index}.value`}
                        title={form.label}
                      >
                        {form.label}
                        <JsonSchemaTooltip config={form} hasArrow placement="top">
                          <InfoOutlineIcon alignSelf="center" ml="1" color="gray.400" />
                        </JsonSchemaTooltip>
                      </FormLabel>
                      <ConfigurationPanelFormField
                        config={form}
                        index={index}
                        fieldPathPrefix={fieldPathPrefix}
                      />
                    </FormControl>
                  </Box>
                </Box>
              ))}
            </Grid>
          </Box>
        )
      })}
    </>
  )
}
